import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MigrationData } from '../MigrationData';
import * as moment from 'moment';
import Chart from 'chart.js';

@Component({
  selector: 'app-charte',
  templateUrl: './charte.component.html',
  styleUrls: ['./charte.component.scss']
})

export class CharteComponent implements OnInit, OnChanges {

  constructor() { }

  @Input() migrationsTreated: MigrationData;
  lineChartLabels: Array<string> = [];
  listGate: Array<string> = [];
  selectedGate: 0;
  listCountry: Array<string> = [];
  selectedCountry: 0;
  myChart: Chart;
  
  ngOnInit() {
    this.lineChartLabels = [];
    this.updateListGate();
    this.updateListCountry();
    const list = this.migrationsTreated[0].countries[0].traffic;
    for (var i = 0; i < list.length; i++) {
      this.lineChartLabels.push(list[i].date);
    }

    this.updateChart();
  }

  ngOnChanges(SimpleChanges) {

  }


  private updateChart(): void {
    const gate = this.selectedGate;
    const country = this.selectedCountry;
    var datasets = [];
    const entry = this.migrationsTreated[gate].countries[country];
    var dataa = [];
    for (var j = 0; j < entry.traffic.length; j++) {
      dataa.push(entry.traffic[j].count);
    }
    var dataSet = {
      label: entry.country,
      data: dataa,
      hidden: false,
      backgroundColor: [
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 1
    };
    datasets.push(dataSet);


    var ctx = document.getElementById("myChart");
    this.myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.lineChartLabels,
        datasets: datasets
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  stuff(){
    console.log(this.migrationsTreated);
  }

  // update list gate
  private updateListGate(): void {
    var gates = new Set();
    for (var i = 0; i < this.migrationsTreated.length; i++) {
      gates.add(this.migrationsTreated[i].gate);
    }
    this.listGate = Array.from(gates);
    this.selectedGate = 0;
  }

  // update list country
  private updateListCountry(): void {
    var countries = new Set();
    var list = this.migrationsTreated[this.selectedGate].countries;
    for (var i = 0; i < list.length; i++) {
      countries.add(list[i].country);
    }
    this.listCountry = Array.from(countries);
    this.selectedCountry = 0;
  }

  public changeGate(event): void {
    console.log("GATE BECAME " + event);
    this.selectedGate = event;
    this.updateListCountry();
    this.updateChart();

  }
  public changeCtry(event): void {
    console.log("GATE BECAME " + event);
    this.selectedCountry = event;
    this.updateChart();
  }

}


// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/charte/charte.component.ts